module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifRegular.1a0397db.otf";